require('../app/ya_map.coffee')
window.pageInitFlag = false

pageInit = ->

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/contacts.coffee